import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="bg-[#f8f8f8] text-[#222] px-4 sm:px-6 lg:px-20 py-10">
        <div className="max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Kolom 1: Kantor */}
          <div>
            <h4 className="font-semibold text-red-600 mb-4 font-pontano">
              Kantor
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start gap-2">
                <img
                  src="/images/asset/location.svg"
                  alt="Alamat"
                  className="w-4 h-4 mt-1"
                />
                <span className="font-inter">
                  Jl. Griya Utama, Komplek Rekan Puri Mutiara Blok BC No. 12/15,
                  Jakarta Utara 14350
                </span>
              </li>
              <li className="flex items-center gap-2">
                <img
                  src="/images/asset/phone.svg"
                  alt="Phone"
                  className="w-4 h-4 mt-1"
                />
                <span className="font-inter">(021) 22651400</span>
              </li>
              <li className="flex items-center gap-2">
                <img
                  src="/images/asset/email.svg"
                  alt="Email"
                  className="w-4 h-4 mt-1"
                />
                <span className="font-inter">danapensiun@toyota.co.id</span>
              </li>
            </ul>
            <a
              href="mailto:danapensiun@toyota.co.id"
              className="inline-block mt-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-sm transition"
            >
              Hubungi Kami
            </a>
          </div>

          {/* Kolom 2: Menu */}
          <div>
            <h4 className="font-semibold text-red-600 mb-4 font-pontano">
              Menu
            </h4>
            <ul className="space-y-2 text-sm text-gray-700 font-inter">
              <li>
                <Link to="/" className="hover:text-red-600">
                  Beranda
                </Link>
              </li>
              <li>
                <Link to="/layanan" className="hover:text-red-600">
                  Layanan
                </Link>
              </li>
              <li>
                <Link to="/tentang-kami" className="hover:text-red-600">
                  Tentang Kami
                </Link>
              </li>
              <li>
                <Link to="/berita" className="hover:text-red-600">
                  Berita
                </Link>
              </li>
              <li>
                <Link to="/laporan" className="hover:text-red-600">
                  Laporan
                </Link>
              </li>
              <li>
                <Link to="/peraturan" className="hover:text-red-600">
                  Peraturan
                </Link>
              </li>
            </ul>
          </div>

          {/* Kolom 3: Legalitas */}
          <div>
            <h4 className="font-semibold text-red-600 mb-4 font-pontano">
              Legalitas Dana Pensiun Toyota Astra
            </h4>
            <div className="flex items-start gap-3">
              <img
                src="/images/asset/ojk.svg"
                alt="OJK"
                className="w-16 h-auto"
              />
              <p className="text-sm text-gray-700 leading-relaxed font-inter">
                Dana Pensiun Toyota Astra berizin <br />
                dan diawasi oleh Otoritas Jasa <br />
                Keuangan
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
